import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { reviewDetailsModel } from '../models/reviews.models'
import { map } from 'rxjs/operators'

@Injectable({
	providedIn: 'root',
})
export class ReviewsService {
	constructor(private http: HttpClient) {}
	getAllReviews(filter: any) {
		return this.http.post(ApiEndPoint.getAllReviewsApi, filter)
	}
	changeReviewStatus(body: any) {
		return this.http.post(ApiEndPoint.changeReviewStatusApi, body)
	}
	getPendingCount(body: any) {
		return this.http.post(ApiEndPoint.getReviewPendingCountApi, body)
	}
	getReviewDetails(id: number) {
		return this.http
			.get(`${ApiEndPoint.getReviewDetailsApi}?id=${id}`)
			.pipe(map((res: any) => res.result as reviewDetailsModel))
	}
}
